{
  "title": "Edit Roles",
  "savedTitle": "Roles Saved",
  "saveLabel": "Save roles",
  "savingLabel": "Saving",
  "assigned_one": "{{person}} was assigned this training for their new role:",
  "assigned_other": "{{person}} was assigned this training for their new roles:",
  "fallbackPerson": "This volunteer",
  "fallbackModule": "Training Module",
  "due": "Due {{date}}",
  "caption": "{{person}} on the {{team}} team",
  "noRoles": "This team hasn't defined any roles yet.",
  "createRoles": "Create Roles"
}
